import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChart1"><Path fillRule="evenodd" clipRule="evenodd" d="M2 19V3H22V19H15.9943L16.9272 22.2651L15.4849 22.6772L14.4343 19H9.56573L8.5151 22.6772L7.07282 22.2651L8.0057 19H2ZM8.5 12H7V15H8.5V12ZM12.75 7V15H11.25V7H12.75ZM17 10H15.5V15H17V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart1;
